import { useCallback } from "react";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import TemplateHeader from "template-store/components/template-header/template-header";

import { getPlatformAddSolutionLink } from "/constants/links";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getCategoriesData } from "template-store/services/solution-categories-service";
import TemplatePageTabs from "template-store/components/template-page-tabs/template-page-tabs";
import { SIGN_UP_WITH_TEMPLATE_CLICKED } from "constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { getSolutionEnglishName } from "template-store/services/solution-data-service";

import { componentStyles } from "./desktop-template-page-content.scss";

const DesktopTemplatePageContent = (props) => {
  const { template, templateId, translate, allCategories, tabsMetadata } = props;
  const templateData = template?.data;

  const onUseTemplateClickAction = useCallback(() => {
    trackEvent(SIGN_UP_WITH_TEMPLATE_CLICKED, { kind: templateId, info1: getSolutionEnglishName(template) });
  }, [template, templateId]);

  return (
    <div className="desktop-template-page-content-component">
      <div className="template-top-section-wrapper">
        <div className="header-wrapper">
          <TemplateHeader
            templateName={templateData?.name}
            templateCategoriesData={getCategoriesData(allCategories, templateData?.categories)}
            categoriesPrefixText={translate("templateCenter.category.idealFor")}
          />
        </div>
        <div className="button-wrapper">
          <RegularButton
            buttonText={translate("templateCenter.template.useTemplate")}
            url={getPlatformAddSolutionLink(templateId)}
            isOpenLinkInNewTab={true}
            onClick={onUseTemplateClickAction}
          />
        </div>
      </div>

      <div className="template-description-wrapper">
        <div className="template-description"> {templateData?.description}</div>
      </div>

      <div className="template-page-tabs-wrapper">
        <TemplatePageTabs templateData={templateData} tabsMetadata={tabsMetadata} />
      </div>

      <style jsx>{componentStyles}</style>
    </div>
  );
};

DesktopTemplatePageContent.defaultProps = {};

export default withGenericConfig(DesktopTemplatePageContent);
